import { useIntl } from 'react-intl';

import { CargoCharacteristicDto, getCargoCharacteristicTranslationId } from 'Modules/Cargo';
import { store } from 'Models/Store';
import { Flex } from 'Views/Components/Flex/Flex';
import { CheckboxInput } from 'Views/Components/New/CheckboxInput';
import { useBookingWizardDataStore } from '../../BookingWizardDataStore';
import { VehicleTabActionCreators, wizardDataVehicleTabReducer } from './Reducers/vehicleTabReducer';

function TrailerCargoCharacteristicDetails() {
	const intl = useIntl();
	const { wizardData, setWizardData } = useBookingWizardDataStore();

	if (store.selectableTrailerCargoCharacteristics.length === 0) {
		return <></>;
	}

	if (wizardData.innerWizardData.type !== 'vehicle') {
		return <></>;
	}

	const onChange = ({ id, name }: CargoCharacteristicDto) => {
		const newData = wizardDataVehicleTabReducer(
			wizardData,
			VehicleTabActionCreators.changeTrailerCharacteristic({ characteristicId: id, name }),
		);
		if (newData) {
			setWizardData(newData);
		}
	};

	return (
		<Flex direction="col" flex={1} gap="xs">
			{store.selectableTrailerCargoCharacteristics.map(characteristic => {
				if (wizardData.innerWizardData.type !== 'vehicle') {
					return <></>;
				}

				const inheritedCharacteristics =
					store.towOnTypeCharacteristicsMap[wizardData.innerWizardData.trailerTypeId ?? ''] ?? [];
				const selectedCharacteristics = wizardData.innerWizardData.trailerCargoCharacteristics.map(
					x => x.characteristicId,
				);
				const characteristics = [...inheritedCharacteristics, ...selectedCharacteristics];
				const characteristicExists = characteristics.find(x => x === characteristic.id);

				const disabled = inheritedCharacteristics.find(x => x === characteristic.id);

				const label = intl.formatMessage({
					id: getCargoCharacteristicTranslationId(characteristic),
					defaultMessage: characteristic.name,
				});

				return (
					<CheckboxInput
						className="trailer-characteristic-checkbox"
						key={characteristic.id}
						label={label}
						disabled={!!disabled}
						checked={!!characteristicExists}
						onChange={() => onChange(characteristic)}
					/>
				);
			})}
		</Flex>
	);
}

export default TrailerCargoCharacteristicDetails;
